import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as ROUTES from '../constants/routes';
import { toggleModal } from '../reducers/modalReducer';
import { postRequest, showMessage } from '../config';
import { Link } from 'react-router-dom';
import AnimatedPage from '../components/AnimatedPage';

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const resetStates = () => {
        setForgotPasswordEmail('');
        setIsLoading(false);
    };

    const handleResetPassword = async () => {
        if (!forgotPasswordEmail || forgotPasswordEmail == '') return showMessage('Please provide email');

        setIsLoading(true);

        let response = await postRequest('/user/forgotPassword', { email: forgotPasswordEmail });
        if (response && response['code'] == 200) {
            resetStates();
            dispatch(toggleModal({ open: "resendForgotPasswordEmail", historyData: { email: forgotPasswordEmail } }))
            showMessage(response['message']);
        }

        setIsLoading(false);
    };


    return (
        <>
            <AnimatedPage>
                <div className="df bg1 pr brne bscov h100vh login-page" style={{ backgroundImage: `url(${require('../../images/landingpage/form-background.png')})` }}>
                    <div className={`login-container`}>
                        <div className={`tslp tty0`}>
                            <p className="fw500 fs2-125rem c15" style={{ lineHeight: '40.2px' }}>Forgotten password?</p>
                            <p className='c15 maw600px my1-5rem'>Enter the email address linked to your account and we’ll send you a link to reset your password.</p>
                        </div>
                        <div className="pt1rem pb3rem pr8rem">
                            <div className="pt0-5rem pb0-5rem pr df aic">
                                <input
                                    id='forgotPasswordEmail'
                                    type='email'
                                    style={{ paddingLeft: '50px' }}
                                    value={forgotPasswordEmail || ''}
                                    className='pl1rem lpins w100 br10px p1rem custom-input'
                                    placeholder='Email'
                                    onChange={(e) => setForgotPasswordEmail(e['target']['value'])}
                                />
                                <svg style={{ left: '20px' }} className="pa" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.1875 0.375H1.8125C1.36495 0.375 0.935725 0.55279 0.619257 0.869257C0.30279 1.18572 0.125 1.61495 0.125 2.0625V9.9375C0.125 10.3851 0.30279 10.8143 0.619257 11.1307C0.935725 11.4472 1.36495 11.625 1.8125 11.625H14.1875C14.6351 11.625 15.0643 11.4472 15.3807 11.1307C15.6972 10.8143 15.875 10.3851 15.875 9.9375V2.0625C15.875 1.61495 15.6972 1.18572 15.3807 0.869257C15.0643 0.55279 14.6351 0.375 14.1875 0.375ZM13.9456 1.5L8.24187 6.045C8.07875 6.19688 7.92125 6.19688 7.72438 6.045L2.05437 1.5H13.9456ZM14.1875 10.5H1.8125C1.66332 10.5 1.52024 10.4407 1.41475 10.3352C1.30926 10.2298 1.25 10.0867 1.25 9.9375V2.29875L6.99312 6.87187C7.26606 7.13682 7.63087 7.28597 8.01125 7.28813C8.36973 7.28661 8.71398 7.1477 8.97312 6.9L14.75 2.29875V9.9375C14.75 10.0867 14.6907 10.2298 14.5852 10.3352C14.4798 10.4407 14.3367 10.5 14.1875 10.5Z" fill="black" />
                                </svg>
                            </div>
                            <div className='df aic jcsb mt1-5rem'>
                                <button
                                    style={{ width: '50%', height: '50px', lineHeight: '20px' }}
                                    className={`registerButtonAnimation shadow rainbow c1 bg4 br35px mt1rem mb1rem mr2-5rem cp fw600 fs1-25rem pr zi0 br10px`}
                                    onClick={() => handleResetPassword()}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : 'Reset Password'}
                                </button>
                            </div>
                            <div className='df jcsb mt0-5rem'>
                                <span className='c15 fs1rem'>
                                    Don’t have an account?
                                    <Link to={ROUTES.REGISTER} className='fs1rem cp fw600 tdu c3 ml0-5rem'>Create New Account </Link>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="pr bscov brnr df jce aie form-right-image"
                        style={{
                            width: "40%",
                            backgroundSize: '100%'
                        }}>
                    </div>
                </div>
            </AnimatedPage>
        </>
    )
}

export default ForgotPassword